import axios from 'axios'
import jwt_decode from 'jwt-decode';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';

import React, { useState, useEffect } from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { 
  LicenseInfo,
  jaJP,
} from '@mui/x-data-grid-pro';


import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import Navbar from '../../components/layout/Navbar'
import HeadLine1 from '../common/HeadLine1.js'

import BudgetActual from './BudgetActual.js';
import DailySales from './DailySales.js';
import YearSales from './YearSales.js';
import MonthSales from './MonthSales.js';

LicenseInfo.setLicenseKey(
  process.env.REACT_APP_MUI_LICENSE,
);

const theme = createTheme(
  jaJP,
);

const getFirstDayOfMonth = (date) => {
  // 引数の日付から年と月を取得
  const year = date.getFullYear();
  const month = date.getMonth(); // 月は0始まりなのでそのまま使用
  
  // 月の初日を作成
  return new Date(year, month, 1);
}

export default function User(props) {
  const { token } = props;

  const [backdropOpen, setBackdropOpen] = useState(false);

  const [employeeCode, setEmployeeCode] = React.useState(jwt_decode(token).employee_code);
  const [salesMonth, setSalesMonth] = React.useState(dayjs(getFirstDayOfMonth(new Date())));
  const [startEnabledMonth, setStartEnabledMonth] = React.useState(new Date());
  const [endEnabledMonth, setEndEnabledMonth] = React.useState(new Date());
  const [startDataDate, setStartDataDate] = React.useState(new Date());
  const [endDataDate, setEndDataDate] = React.useState(new Date());

  const handleBackdropClose = () => {
    setBackdropOpen(false);
  };


  return (
    <Box>      
      <Navbar {...props}>
        <HeadLine1>
          進捗予実管理
        </HeadLine1>

        <DailySales
          token={token} 
          salesMonth={salesMonth}
        />
        <Divider />
        <BudgetActual
          token={token}
          salesMonth={salesMonth}
        />
        <YearSales
          token={token}
          salesMonth={salesMonth}
        />
        <MonthSales
          token={token}
          salesMonth={salesMonth}
        />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropOpen}
          onClick={handleBackdropClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

      </Navbar>
    </Box>
  )
}